import { render, staticRenderFns } from "./my_comment_news.vue?vue&type=template&id=1739dcf5&scoped=true"
import script from "./my_comment_news.vue?vue&type=script&lang=js"
export * from "./my_comment_news.vue?vue&type=script&lang=js"
import style0 from "./my_comment_news.vue?vue&type=style&index=0&id=1739dcf5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1739dcf5",
  null
  
)

export default component.exports